<template>
  <div :class="{'lds-ring': true, auto, small}">
    <div :style="{ borderColor: borderColor }"></div>
    <div :style="{ borderColor: borderColor }"></div>
    <div :style="{ borderColor: borderColor }"></div>
    <div :style="{ borderColor: borderColor }"></div>
  </div>
</template>

<script>
export default {
  props: {
    color: String,
    auto: Boolean,
    small: Boolean
  },
  name: 'Loader',
  computed: {
    borderColor() {
      if(this.color) {
        return `${this.color} transparent transparent transparent`;
      } else {
        return `#dedede transparent transparent transparent`;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.lds-ring {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}
.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 60px;
  height: 60px;
  border: 6px solid;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
}
.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}
@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.auto {
  div {
    width: 1.3em;
    height: 1.3em;
    border: 0.15em solid;
  }
}

.small {
  div {
    width: 30px;
    height: 30px;
    border: 3px solid;
  }
}
</style>